// assets
import {
  DashboardOutlined,
  UserOutlined,
  CalendarOutlined,
  FileTextOutlined,
  PictureOutlined,
  TeamOutlined,
  BarChartOutlined,
  SettingOutlined,
  NotificationOutlined,
  QuestionCircleOutlined,
  SoundOutlined,
  AppstoreOutlined,
  MedicineBoxOutlined,
  UserDeleteOutlined,
  CrownOutlined,
  CheckCircleOutlined,
  LineChartOutlined,
  FunnelPlotOutlined,
  BankOutlined,
  StarOutlined,
  HeartOutlined,
  DollarOutlined,
  ReadOutlined
} from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  UserOutlined,
  CalendarOutlined,
  FileTextOutlined,
  PictureOutlined,
  TeamOutlined,
  BarChartOutlined,
  SettingOutlined,
  NotificationOutlined,
  QuestionCircleOutlined,
  SoundOutlined,
  AppstoreOutlined,
  MedicineBoxOutlined,
  UserDeleteOutlined,
  CrownOutlined,
  CheckCircleOutlined,
  LineChartOutlined,
  FunnelPlotOutlined,
  BankOutlined,
  StarOutlined,
  HeartOutlined,
  DollarOutlined,
  ReadOutlined
};

// ==============================|| MENU ITEMS ||============================== //

const adminMenuItems = {
  items: [
    // ==============================|| 대시보드 ||============================== //
    {
      id: 'group-dashboard',
      title: '홈',
      type: 'group',
      children: [
        {
          id: 'dashboard',
          title: '대시보드',
          type: 'item',
          url: '/dashboard',
          icon: icons.DashboardOutlined,
          breadcrumbs: false
        }
      ]
    },

    // ==============================|| 회원관리 ||============================== //
    {
      id: 'group-members',
      title: '관리',
      type: 'group',
      children: [
        {
          id: 'members',
          title: '회원관리',
          type: 'collapse',
          icon: icons.UserOutlined,
          children: [
            {
              id: 'member-list',
              title: '회원목록',
              type: 'item',
              url: '/members/list'
            },
            {
              id: 'member-withdrawn',
              title: '탈퇴 회원 관리',
              type: 'item',
              url: '/members/withdrawn'
            }
          ]
        },

        // ==============================|| 관리자관리 ||============================== //
        {
          id: 'managers',
          title: '관리자관리',
          type: 'collapse',
          icon: icons.TeamOutlined,
          roles: ['SUPER_ADMIN'],
          children: [
            {
              id: 'manager-list',
              title: '관리자 목록',
              type: 'item',
              url: '/managers/list'
            }
          ]
        },

        // ==============================|| 예약관리 ||============================== //
        {
          id: 'reservations',
          title: '예약관리',
          type: 'collapse',
          icon: icons.CalendarOutlined,
          children: [
            {
              id: 'consultation-list',
              title: '간편예약 신청 목록',
              type: 'item',
              url: '/reservations/consultations'
            },
            // {
            //   id: 'reservation-manage',
            //   title: '예약 확정/수정/취소',
            //   type: 'item',
            //   url: '/reservations/manage'
            // }
          ]
        },

        // ==============================|| 게시판관리 ||============================== //
        {
          id: 'boards',
          title: '게시판 관리',
          type: 'collapse',
          icon: icons.FileTextOutlined,
          children: [
            {
              id: 'notice',
              title: '공지사항',
              type: 'item',
              url: '/boards/notices'
            },
            {
              id: 'faq',
              title: '자주묻는 질문',
              type: 'item',
              url: '/boards/faqs'
            },
            {
              id: 'customer-voice',
              title: '고객의 소리',
              type: 'item',
              url: '/boards/customer-voices'
            },
            {
              id: 'reviews',
              title: '치료후기',
              type: 'item',
              url: '/reviews'
            },
            {
              id: 'contributions',
              title: '사회공헌',
              type: 'item',
              url: '/contributions'
            },
            {
              id: 'tax-exempt',
              title: '비급여안내',
              type: 'item',
              url: '/boards/tax-exempt'
            }
          ]
        },

        // ==============================|| 콘텐츠관리 ||============================== //
        {
          id: 'contents',
          title: '콘텐츠관리',
          type: 'collapse',
          icon: icons.PictureOutlined,
          children: [
            {
              id: 'banner',
              title: '배너 관리',
              type: 'item',
              url: '/contents/banners'
            },
            {
              id: 'popup',
              title: '팝업 관리',
              type: 'item',
              url: '/contents/popups'
            },
            // {
            //   id: 'homepage-section',
            //   title: '홈페이지 섹션 관리',
            //   type: 'item',
            //   url: '/contents/sections'
            // }
          ]
        },

        // ==============================|| 의료진관리 ||============================== //
        {
          id: 'medical',
          title: '의료진관리',
          type: 'collapse',
          icon: icons.MedicineBoxOutlined,
          children: [
            {
              id: 'doctor-list',
              title: '의료진 프로필 관리',
              type: 'item',
              url: '/medical/doctors'
            },
            {
              id: 'doctor-schedule',
              title: '진료 시간표 관리',
              type: 'item',
              url: '/medical/schedules'
            }
          ]
        },

        // ==============================|| 진료센터관리 ||============================== //
        // {
        //   id: 'centers',
        //   title: '진료센터관리',
        //   type: 'item',
        //   url: '/centers',
        //   icon: icons.BankOutlined
        // },


        // ==============================|| 통계 ||============================== //
        {
          id: 'statistics',
          title: '통계',
          type: 'collapse',
          icon: icons.BarChartOutlined,
          children: [
            {
              id: 'reservation-stats',
              title: '예약 통계',
              type: 'item',
              url: '/statistics/reservations'
            }
          ]
        },

        // ==============================|| 환경설정 ||============================== //
        {
          id: 'settings',
          title: '환경설정',
          type: 'collapse',
          icon: icons.SettingOutlined,
          children: [
            {
              id: 'seo',
              title: 'SEO 관리',
              type: 'item',
              url: '/settings/seo'
            }
          ]
        }
      ]
    }
  ]
};

export default adminMenuItems;
